import { render } from "./InventoryItemDetails.vue?vue&type=template&id=5e6ebd75&scoped=true"
import script from "./InventoryItemDetails.vue?vue&type=script&lang=js"
export * from "./InventoryItemDetails.vue?vue&type=script&lang=js"

import "./InventoryItemDetails.vue?vue&type=style&index=0&id=5e6ebd75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6ebd75"]])

export default __exports__